import React from "react";
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'

import { FiTwitter, FiMail } from 'react-icons/fi'

import featuresImg from '../assets/features.png';
import createLockboxImg from '../assets/create_lockbox.png';
import useLockboxImg from '../assets/use_lockbox.png';
import a16zCSSImg from '../assets/a16zCSSImg.png';
import unusualVCImg from '../assets/unusualVCImg.jpg';
import telosImg from '../assets/telos.png';
import trondaoImg from '../assets/trondao.png';
import hucpImg from '../assets/hucp.jpg';
import cbeImg from '../assets/harvard_cbe_logo.png';
import logoImg from '../assets/lockbox_horz_white_text.svg';
import '../styles/App.css';

require('dotenv').config()

function LandingPage() {

  const handleDisableSubmit = (event) => {
    event.preventDefault();
    var button = event.currentTarget;
    button.disabled = true;
    let form = document.getElementById('waitlist-form');
    const data = new FormData(form);
    fetch(process.env.REACT_APP_WAITLIST_ENDPOINT_URL, {
      method: 'POST',
      body: data,
    })
      .then(() => {
        alert("Success!");
        button.disabled = false;
        form.reset()
      })
  }

  return (
    <div>
      <div className="home">
        <Navbar bg="dark" variant="dark">
          <Container>
            <Navbar.Brand href="/">
              <img
                alt=""
                src={logoImg}
                height="36"
                className="d-inline-block align-bottom"
              />
            </Navbar.Brand>
            <Nav className="justify-content-end">
              <Nav.Link href="#home" style={{ fontSize: "18px" }}>Home</Nav.Link>
              <Nav.Link href="#features" style={{ fontSize: "18px" }}>Features</Nav.Link>
              <Nav.Link href="#contact" style={{ fontSize: "18px" }}>Contact</Nav.Link>
            </Nav>
          </Container>
        </Navbar>
        <div>
          <br />
          <br />
          <br />
          <h1 className="text-center" style={{ fontSize: "4em" }}><strong>Take control of your crypto.</strong></h1>
          <br />
          <br />
          <p className="text-center" style={{ fontSize: "1.4em" }}>Lockbox is an innovative, smart contract based self-custody solution <br /> for permissioned and scalable crypto treasury management.</p>
          <br />

          <div className="text-center">
            <form id="waitlist-form">
              <input type="email" className="form-control w-25 center-block" placeholder="Email" aria-label="Recipient's email" aria-describedby="basic-addon2" name="Email"></input>
              <br />
              <Button variant="dark" type="submit" onClick={handleDisableSubmit} id="submitBtn">Join Waitlist</Button>
            </form>
          </div>
        </div>
        <div className="features">
          <div>
            <div className="text-center">
              <br />
              <img src={featuresImg} alt="features" width="60%" />
              <br />
            </div>
          </div>
        </div>
      </div>
      <Container className="features2" id="features">
        <br />
        <Row>
          <h1 className="text-center" style={{ fontSize: "3em" }}>Fund management has never been easier.</h1>
        </Row>
        <br />
        <Row>
          <Col md="8">
            <img src={createLockboxImg} alt="Create Lockbox Page" width="100%" />
          </Col>
          <Col md="4">
            <br />
            <br />
            <br />
            <br />
            <br />
            <h2>Two clicks<br />to create a new Lockbox.</h2>
            <br />
            <br />
            <h2>One click<br />to launch an existing Lockbox.</h2>
          </Col>
        </Row>
        <br />
        <br />
        <Row>
          <Col md="4">
            <br />
            <br />
            <br />
            <h2>Seamless interactions with...</h2>
            <ul>
              <li>Permissions</li>
              <li>Proposals</li>
              <li>Deposits</li>
              <li>Transfers</li>
              <li>Allow Lists</li>
              <li>Payroll</li>
              <li>Integrations</li>
              <li>Fiat ramps</li>
            </ul>
            <h2>... in just a few clicks.</h2>
          </Col>
          <Col>
            <img src={useLockboxImg} alt="Use Lockbox Page" width="100%" />
          </Col>
        </Row>
      </Container>
      <div className="text-center">
        <h2>Join the waitlist today!</h2>
        <br />
        <form id="waitlist-form">
          <input type="email" className="form-control w-25 center-block" placeholder="Email" aria-label="Recipient's email" aria-describedby="basic-addon2" name="Email"></input>
          <br />
          <Button variant="dark" type="submit" onClick={handleDisableSubmit} id="submitBtn">Join Waitlist</Button>
        </form>
      </div>
      <br />
      <br />
      <div className="backing">
        <h2 className="heading text-center">Supported By</h2>
        <div className="text-center">
          <img src={a16zCSSImg} alt="a16z Crypto Startup School" style={{height: "160px", margin: "0px 0px 32px 0px"}} />
          <br/>
          <img src={unusualVCImg} alt="Unusual Ventures" style={{height: "80px", padding: "0px 16px 4px 16px", margin: "0px 0px 4px 0px"}}/>
          <img src={hucpImg} alt="Harvard Undergraduate Capital Partners" style={{ height: "58px", padding: "0px 16px 0px 16px", margin: "0px 0px 4px 0px" }} />
          <img src={cbeImg} alt="Harvard CBE" style={{ height: "70px", padding: "0px 16px 0px 16px", margin: "0px 0px 4px 0px" }} />
          <br/>
          <img src={telosImg} alt="Telos Foundation" style={{ height: "68px", padding: "0px 16px 16px 8px" }} />
          <img src={trondaoImg} alt="Tron DAO" style={{ height: "80px", padding: "0px 8px 16px 16px" }} />
        </div>
      </div>
      <footer className="container-fluid text-center" id="contact">
        <h2 style={{ paddingTop: "24px" }}>Connect with us!</h2>
        <a href="https://twitter.com/getLockbox" target="_blank" rel="noreferrer"><FiTwitter style={{ color: "rgb(29, 161, 242)", fontSize: "40px", padding: "8px" }} /></a>
        <a href="mailto:hello@getlockbox.xyz" target="_blank" rel="noreferrer"><FiMail style={{ color: "white", fontSize: "40px", padding: "8px" }} /></a>
      </footer>
    </div>
  )
}

export default LandingPage;
